import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';

export default Object.freeze({
	GENERAL: `${RouteNames.SINGLE_SIGN_ON}-general`,
	MAPPING: `${RouteNames.SINGLE_SIGN_ON}-mapping`,
	PERMISSIONS: `${RouteNames.SINGLE_SIGN_ON}-permissions`,
});
